import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ResponseDto } from '../../../dtos/response.dto';
import { PromoCodeDto } from '../../../dtos/promo-code.dto';
import { environment } from '../../../../environments/environment';
import { tap } from 'rxjs/operators';
import { DeviceService } from '../../../services/device-detector/device.service';

@Injectable({
  providedIn: 'root'
})
export class PromoCodeService {
  private http = inject(HttpClient);
  private deviceService = inject(DeviceService);

  private promoCode: PromoCodeDto;
  private savedPromoCode: string = 'savedPromoCode';
  promoCodeUpdated$ = new Subject<PromoCodeDto>();
  get getPromoCode() {return this.promoCode}

  constructor() {
    const storedPromoCode = this.getLocalStoragePromoCode();
    this.promoCode = storedPromoCode && storedPromoCode != 'undefined' ? JSON.parse(storedPromoCode) : undefined;
    this.sendPromoCodeUpdatedData(this.promoCode);
  }

  sendPromoCodeUpdatedData(promoCode: PromoCodeDto) {
    this.promoCodeUpdated$.next(promoCode);
  }

  getPromoCodeByName(promoCodeName: string): Observable<ResponseDto<PromoCodeDto>> {
    return this.http.get<ResponseDto<PromoCodeDto>>(`${environment.apiHost}/api/v1/client/promo-codes/${promoCodeName}`)
  }

  getLocalStoragePromoCode() {
    if (this.deviceService.isPlatformBrowser()) {
     return localStorage.getItem(this.savedPromoCode);
    }
  }

  clearLocalStoragePromoCode() {
    if (this.deviceService.isPlatformBrowser()) {
      localStorage.removeItem(this.savedPromoCode);
    }
  }

  setLocalStoragePromoCode() {
    if (this.deviceService.isPlatformBrowser()) {
      localStorage.setItem(this.savedPromoCode, JSON.stringify(this.promoCode));
    }
  }

  cancelPromoCodeData() {
    this.clearLocalStoragePromoCode();
    this.promoCode = undefined;
    this.sendPromoCodeUpdatedData(this.promoCode);
  }

  applyPromoCode(inputValue: string): Observable<ResponseDto<PromoCodeDto>> {
    return this.getPromoCodeByName(inputValue)
      .pipe(tap(
        response => {
          this.promoCode = response.data;
          this.setLocalStoragePromoCode();
          this.sendPromoCodeUpdatedData(this.promoCode);
        },
        () => {
          this.cancelPromoCodeData();
        }
      ));
  }

}
